<template>
  <div>
    <header1></header1>
    <div class="new_content" style="background: #FFFFFF;width:1002px;">
      <div class="new_findPwd_title" style="height: 76px;padding-left: 15px;">
        <router-link class="new_findPwd_title_sel" to="/findByMobile">手机找回密码</router-link>
        <!--<router-link to="/findByEmail" >邮箱找回密码</router-link>-->
        <!--<router-link to="/findByWX">微信找回密码</router-link>-->
      </div>
      <div class="new_findPwd_main">
        <el-steps :active="active" :space="350" finish-status="success"
          style="margin-left: 100px; margin-bottom: 30px;">
          <el-step title="验证手机号"></el-step>
          <el-step title="设置密码"></el-step>
          <el-step title="设置成功"></el-step>
        </el-steps>
        <div v-show="active==1">
          <el-form ref="mobileForm" :model="mobileForm" :rules="mobileRules" label-width="100px">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="mobileForm.mobile" style="width: 50%"></el-input>
              <el-button :disabled="sendSmsButtonDisabled" size="small"
                style="margin-left: 20px;border-color:#1D7A8E;background: #1D7A8E;"
                type="primary" @click.native="sendSmsMethod">{{ sendSmsButtonText }}
              </el-button>
            </el-form-item>
            <el-form-item label="验证码" prop="mobileCode">
              <el-input v-model="mobileForm.mobileCode" style="width: 20%"></el-input>
              <a class="yz ml-20 pa" href="javascript:"
                title="①手机接收短信偶尔会有延时状况，请耐心等待;②尝试到手机短信拦截记录里找找看;③若有疑问请拨打客服电话：400-822-2055">没有收到验证码？</a>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button style="width:30%;background: #1D7A8E;border:1px #1D7A8E solid" type="primary"
                @click.native="nextMobile">下一步
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active==2">
          <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
            <el-form-item label="新密码" prop="newPwd">
              <el-input v-model="pwdForm.newPwd" style="width: 50%" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="reNewPwd">
              <el-input v-model="pwdForm.reNewPwd" style="width: 50%" type="password"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button style="width:30%;" type="primary" @click="updatePwd">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active==3">
          <div class="new_content">
            <div style="padding:5% 0;">
              <p class="new_zc_sucess">找回密码成功! </p>
              <p class="new_zc_welcome"><span>{{ userName }}</span>欢迎回来　|　
                <router-link to="/">立即登录</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width:1002px;margin: 0 auto;">
      <footer1></footer1>
    </div>
  </div>
</template>
<style scoped>
.new_findPwd_title {
  height: 37px;
  padding-top: 40px;
}

.new_findPwd_title a {
  line-height: 36px;
  display: block;
  float: left;
  width: 130px;
  height: 36px;
  margin-right: 12px;
  text-align: center;
  color: #5F5F5F;
  border: #C9C9C9 1px solid;
  border-bottom: 0px;
}

.new_findPwd_title a.new_findPwd_title_sel {
  color: #FFFFFF;
  border: #1D7A8E 1px solid;
  border-bottom: 0px;
  background: #1D7A8E;
}

.new_fpwx_title {
  font-weight: bold;
  line-height: 40px;
  text-align: left;
  color: #1D7A8E;
}

.new_fpwx_img {
  text-align: center;
}

.new_findPwd_main {
  width: 100%;
  min-height: 340px;
  padding: 40px 0px 0px 0px;
  border: 1px #C9C9C9 solid;
}

p.new_zc_sucess {
  font-size: 30px;
  line-height: 40px;
  width: 245px;
  height: 40px;
  margin: 0px auto;
  padding-left: 36px;
  text-align: left;
  color: #66A000;
  background: url(../assets/img-4/sucess_bg.gif) no-repeat left center;
}

p.new_zc_welcome {
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}

p.new_zc_welcome span, p.new_zc_welcome a {
  color: #FF5300;
}

p.new_zc_welcome a:hover {
  text-decoration: underline
}
</style>

<script>

import header1 from '../components/Header1'
import footer1 from '../components/Footer1'
import sha256 from 'crypto-js/sha256'

import { sendSms, updatePwd, validateMobileCode, vftelStudent } from '../api/api'

export default {
  components: {
    header1,
    footer1
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!(/^1[3|4|5|7|8][0-9]\d{4,8}$/.test(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        vftelStudent({tel: value}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            if (!data) {
              callback(new Error('手机号未验证，请联系客服400-822-2055！'))
            } else {
              callback()
            }
          }
        })
      }
    }
    var validateVPhoneCode = (rule, value, callback) => {
      if (!this.mobileForm.mobile) {
        callback(new Error('请先获取手机验证码'))
      } else if (!value) {
        callback(new Error('请输入手机验证码'))
      } else {
        validateMobileCode({mobile: this.mobileForm.mobile, code: value}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            if (data.status == 200) {
              callback()
            } else {
              callback(new Error('手机验证码错误'))
            }
          }
        })
      }
    }
    var validateVpassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      mobileForm: {
        mobile: '',
        mobileCode: '',
        newPwd: '',
        reNewPwd: ''
      },
      pwdForm: {
        newPwd: '',
        reNewPwd: ''
      },
      active: 1,
      userName: '',
      sendSmsButtonDisabled: false,
      smsTime: 0,
      mobileRules: {
        mobile: [
          {validator: validateMobile, trigger: 'blur'}
        ],
        mobileCode: [
          {validator: validateVPhoneCode, trigger: 'blur'}
        ]
      },
      pwdRules: {
        newPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 22, message: '长度在 6 到 22 个字符', trigger: 'blur'}
        ],
        reNewPwd: [
          {validator: validateVpassword, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    sendSmsButtonText() {
      if (this.smsTime > 0) {
        if (!this.sendSmsButtonDisabled) {
          this.sendSmsButtonDisabled = true
        }
        return this.smsTime + 's 后重新获取'
      } else {
        this.sendSmsButtonDisabled = false
        return '获取验证码'
      }
    }
  },
  methods: {
    smsTimer() {
      if (this.smsTime > 0) {
        this.smsTime--
        setTimeout(this.smsTimer, 1000)
      }
    },
    sendSmsMethod() {
      this.$refs.mobileForm.validateField('mobile', error => {
        if (!error) {
          let timestamp = new Date().getTime()
          let sign = sha256(this.mobileForm.mobile + 1 + timestamp).toString()
          let param = {
            mobile: this.mobileForm.mobile,
            bType: 1,
            sign: sign,
            timestamp: timestamp
          }
          sendSms(param).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                this.$message({
                  message: data.msg,
                  type: 'success'
                })
                this.smsTime = 60
                this.smsTimer()
              } else {
                this.$message({
                  message: data.msg,
                  type: 'warning'
                })
              }
            } else {
              this.$message.error('网络错误！')
            }
          })
        }
      })
    },
    
    nextMobile() {
      this.$refs.mobileForm.validate((valid) => {
        if (valid) {
          if (this.active++ > 2) this.active = 0
        } else {
          return false
        }
      })
    },
    
    updatePwd() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          let param = {
            newPwd: this.pwdForm.newPwd,
            prama: this.mobileForm.mobile,
            type: 1,
            code: this.mobileForm.mobileCode
          }
          updatePwd(param).then((response) => {
            if (response.status == 200) {
              if (response.data.state == 1) {
                this.userName = response.data.userName
                if (this.active++ > 2) this.active = 0
              } else {
                this.$message({
                  message: '操作失败！请刷新后再试！',
                  type: 'warning'
                })
              }
            } else {
              this.$message.error('网络错误！')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/FindByMobile.vue